import { MODULES } from './metadata';
import { modelReleaseHistory } from './modelReleaseHistory';
import { eciModelScores } from './eciModelScores';
import { capabilityDatasets } from './capability';
import { costEfficiencyDatasets } from './costEfficiency';
import { usageMonetizationDatasets } from './usageMonetization';
import { computeMarketDatasets } from './computeMarket';
import { economicDiffusionDatasets } from './economicDiffusion';

const datasets = [
    modelReleaseHistory,
    eciModelScores,
    ...capabilityDatasets,
    ...costEfficiencyDatasets,
    ...usageMonetizationDatasets,
    ...computeMarketDatasets,
    ...economicDiffusionDatasets,
];

export const getDataset = (datasetId) => (
    datasets.find((dataset) => dataset.datasetId === datasetId)
);

const aiDevelopmentSnapshot = {
    frameworkVersion: 'ai_development_monitor_v1',
    asOf: '2026-08-09',
    modules: MODULES,
    datasets,
    sourceCatalog: [
        {
            id: 'epoch-ai',
            name: 'Epoch AI',
            url: 'https://epoch.ai/data',
            sourceType: 'public_dataset',
            license: 'CC-BY',
        },
        {
            id: 'artificial-analysis',
            name: 'Artificial Analysis',
            url: 'https://artificialanalysis.ai',
            sourceType: 'public_dashboard',
            license: 'Provider terms',
        },
        {
            id: 'metr',
            name: 'METR',
            url: 'https://metr.org/time-horizons/',
            sourceType: 'public_dataset',
            license: 'See source',
        },
        {
            id: 'swe-bench',
            name: 'SWE-bench',
            url: 'https://www.swebench.com/verified.html',
            sourceType: 'public_dataset',
            license: 'See source',
        },
        {
            id: 'livebench',
            name: 'LiveBench',
            url: 'https://github.com/LiveBench/LiveBench',
            sourceType: 'public_dataset',
            license: 'Apache-2.0',
        },
        {
            id: 'aider',
            name: 'Aider',
            url: 'https://aider.chat/docs/leaderboards/',
            sourceType: 'public_dataset',
            license: 'See source',
        },
        {
            id: 'state-bench',
            name: 'Microsoft STATE-Bench',
            url: 'https://microsoft.github.io/STATE-Bench/leaderboard/',
            sourceType: 'public_dashboard',
            license: 'See source',
        },
        {
            id: 'openrouter',
            name: 'OpenRouter',
            url: 'https://openrouter.ai/rankings',
            sourceType: 'public_dashboard',
            license: 'Provider terms',
        },
        {
            id: 'anthropic-economic-index',
            name: 'Anthropic Economic Index',
            url: 'https://huggingface.co/datasets/Anthropic/EconomicIndex',
            sourceType: 'public_dataset',
            license: 'CC-BY',
        },
        {
            id: 'onet',
            name: 'O*NET',
            url: 'https://www.onetcenter.org/database.html',
            sourceType: 'public_dataset',
            license: 'See source',
        },
        {
            id: 'bls',
            name: 'U.S. Bureau of Labor Statistics',
            url: 'https://www.bls.gov/emp/data/occupational-data.htm',
            sourceType: 'official_dataset',
            license: 'U.S. government work',
        },
        {
            id: 'openai-pricing',
            name: 'OpenAI API Pricing',
            url: 'https://developers.openai.com/api/docs/models',
            sourceType: 'official_pricing',
            license: 'Provider terms',
        },
        {
            id: 'anthropic-pricing',
            name: 'Claude Platform Pricing',
            url: 'https://platform.claude.com/docs/en/about-claude/pricing',
            sourceType: 'official_pricing',
            license: 'Provider terms',
        },
        {
            id: 'google-pricing',
            name: 'Gemini Developer API Pricing',
            url: 'https://ai.google.dev/gemini-api/docs/pricing',
            sourceType: 'official_pricing',
            license: 'CC-BY',
        },
        {
            id: 'semianalysis-gpu-index',
            name: 'SemiAnalysis GPU Spot-Contract Composite Index',
            url: 'https://gpu-index.semianalysis.com/',
            sourceType: 'public_dashboard',
            license: 'Provider terms',
        },
        {
            id: 'trendforce',
            name: 'TrendForce',
            url: 'https://www.trendforce.com/presscenter/',
            sourceType: 'public_market_analysis',
            license: 'Provider terms',
        },
    ],
};

export default aiDevelopmentSnapshot;
